/**
 * CRC Drivers shell — tab navigation (mockup order + labels).
 * SoT: gas-export/IndexHTML.html tabs nav + DRIVERS_MOCKUP_AUDIT ROLE_TABS.
 */

export const shellHeader = {
  brandMark: 'CD',
  title: 'CRC Drivers',
  subtitle: 'Fleet lifecycle'
};

export const shellToolbarActions = [];

/**
 * Primary nav — mockup order.
 * badgeCountKey maps bootstrap counts (DriversBootstrapHelper::fetchCounts).
 */
export const shellTabs = [
  {
    key: 'dashboard',
    bootstrapTabKey: 'clevel',
    label: 'Dashboard',
    icon: 'pi-chart-bar',
    path: '/dashboard',
    routeName: 'dashboard',
    requiredAnyPermission: ['dashboard.view.global', 'dashboard.view.department']
  },
  {
    key: 'potential',
    bootstrapTabKey: 'potential',
    label: 'Potential',
    icon: 'pi-users',
    path: '/potential',
    routeName: 'potential',
    badgeCountKey: 'potentialOpen'
  },
  {
    key: 'inprogress',
    bootstrapTabKey: 'inprogress',
    label: 'In Progress',
    icon: 'pi-spinner',
    path: '/in-progress',
    routeName: 'in-progress',
    badgeCountKey: 'InProgress'
  },
  {
    key: 'insclaims',
    bootstrapTabKey: 'insclaims',
    label: 'Insurance & Claims',
    icon: 'pi-shield',
    path: '/insurance-claims',
    routeName: 'insurance-claims',
    badgeCountKey: 'insClaimsOpen'
  },
  {
    key: 'llcs',
    bootstrapTabKey: 'llcs',
    label: 'LLCs',
    icon: 'pi-building',
    path: '/llcs',
    routeName: 'llcs'
  },
  {
    key: 'active',
    bootstrapTabKey: 'active',
    label: 'Active',
    icon: 'pi-truck',
    path: '/active',
    routeName: 'active',
    badgeCountKey: 'Active'
  },
  {
    key: 'inactive',
    bootstrapTabKey: 'inactive',
    label: 'Inactive',
    icon: 'pi-user-minus',
    path: '/inactive',
    routeName: 'inactive',
    badgeCountKey: 'Inactive'
  },
  {
    key: 'statistics',
    bootstrapTabKey: 'statistics',
    label: 'Statistics',
    icon: 'pi-chart-line',
    path: '/statistics',
    routeName: 'statistics'
  }
];

export const shellAdminTabs = [];

export const shellNavSections = [
  {
    id: 'pipeline',
    label: 'Pipeline',
    items: [
      { type: 'tab', tabKey: 'potential' },
      { type: 'tab', tabKey: 'inprogress' }
    ]
  },
  {
    id: 'fleet',
    label: 'Fleet',
    items: [
      { type: 'tab', tabKey: 'active' },
      { type: 'tab', tabKey: 'inactive' }
    ]
  },
  {
    id: 'compliance',
    label: 'Compliance',
    items: [
      { type: 'tab', tabKey: 'insclaims' },
      { type: 'tab', tabKey: 'llcs' }
    ]
  },
  {
    id: 'insights',
    label: 'Insights',
    items: [
      { type: 'tab', tabKey: 'dashboard' },
      { type: 'tab', tabKey: 'statistics' }
    ]
  }
];

const tabByKey = Object.fromEntries(shellTabs.map((t) => [t.key, t]));

export function getShellTabByKey(key) {
  return tabByKey[key] || null;
}

export function getShellAdminTabByKey(key) {
  return null;
}
